import { BetLimitContext } from '@/contexts/BetLimitContext';
import { ROUTE_LOBBY } from '@/models/Route';
import { popupSliceActions } from '@/modules/popup/slice';
import { routeSliceActions } from '@/modules/routeController/slice';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AudioPlayContext } from '../contexts/AudioPlayContext';
import { GameType as GameTypeEnum } from '../models/games/enums/GameType';
import { getMainLimitRedState } from '../modules/main/selector';
import { LimitRed } from '../modules/main/slice/limitRed';
import { SessionStorageKey, useSession } from './storage/useSession';
export const useBetChip = (gameType: GameTypeEnum) => {
    const [selectedChip, setSelectedChip] = useSession<number>(
        SessionStorageKey.ChipIdx,
        1
    );
    const limitRedByGameType = useSelector(getMainLimitRedState);
    const { playButtonAudio } = useContext(AudioPlayContext);

    const [selectedBetRule, setSelectedBetRule] = useState<LimitRed>();
    const [chipList, setChipList] = useState<Array<number>>([]);
    const { MinBetMultiplier } = useContext(BetLimitContext);
    const [currentGameType, setCurrentGameType] = useState(gameType);
    const selectedBetAmount = useMemo(() => {
        if (!chipList || selectedChip <= 0 || selectedChip > chipList.length) {
            return 0;
        }
        return chipList[selectedChip - 1];
    }, [selectedChip, chipList]);
    const needAutoSelect = useRef<boolean>(false);
    const dispatch = useDispatch();

    //only for multibet move to MultiBetLiveContext
    // const [haveNonConfirmedBetTables, sethaveNonConfirmedBetTables] = useState<
    //     Array<number>
    // >([]); //For Multibet
    useEffect(() => {
        if (gameType === GameTypeEnum.MultiBet) {
            setCurrentGameType(GameTypeEnum.Baccarat);
        } else {
            setCurrentGameType(gameType);
            if (gameType === GameTypeEnum.Blackjack2) {
                needAutoSelect.current = true;
            }
        }
    }, [gameType]);

    const handleChipClick = (v: number) => {
        setSelectedChip(v);
        playButtonAudio();
    };
    useEffect(() => {
        console.log('selected::chip::amount', selectedBetAmount);
    }, [selectedBetAmount]);
    useEffect(() => {
        if (gameType) {
            let type = gameType;
            if (gameType === GameTypeEnum.MultiBet) {
                type = GameTypeEnum.Baccarat;
            }
            const limitRedByGame = limitRedByGameType.BetRuleByGameType?.find(
                lr => lr.GameType === type
            );
            if (
                !limitRedByGame ||
                !limitRedByGame.BetRule ||
                limitRedByGame.BetRule.length === 0
            ) {
                if (limitRedByGameType.BetRuleByGameType) {
                    dispatch(routeSliceActions.goto(ROUTE_LOBBY));
                    dispatch(popupSliceActions.open('system.error_m226.17'));
                }
            } else if (limitRedByGame) {
                const limitRed = limitRedByGame.BetRule;
                if (limitRed.length > 0) {
                    // if the are not selected limit, set the first limit in limitReds
                    let selectedLimitRed =
                        limitRed.find(lr => lr.Selected === 1) || limitRed[0];
                    if (!selectedLimitRed && limitRedByGame.RuleToSelect) {
                        selectedLimitRed = limitRedByGame.RuleToSelect;
                    }
                    if (
                        currentGameType == GameTypeEnum.Blackjack2 &&
                        needAutoSelect.current &&
                        MinBetMultiplier
                    ) {
                        const minChip =
                            selectedLimitRed.MinBet * MinBetMultiplier;
                        if (selectedBetAmount < minChip) {
                            const tmp = selectedLimitRed.Token.filter(
                                v =>
                                    v <=
                                    selectedLimitRed.MinBet * MinBetMultiplier
                            );
                            if (tmp && tmp.length > 0) {
                                setSelectedChip(tmp.length);
                            }
                        }
                        needAutoSelect.current = false;
                    }
                    // if (
                    //     currentGameType == GameTypeEnum.Blackjack2 &&
                    //     MinBetMultiplier
                    // ) {
                    //     let newToken = new Array<number>();
                    //     const tmp = selectedLimitRed.Token.filter(
                    //         v => v >= selectedLimitRed.MinBet * MinBetMultiplier
                    //     );
                    //     if (tmp.length > 0) {
                    //         newToken.push(tmp[0]);
                    //         let other = selectedLimitRed.Token.concat([]);
                    //         other.splice(
                    //             selectedLimitRed.Token.indexOf(tmp[0]),
                    //             1
                    //         );
                    //         newToken = newToken.concat(other);
                    //     } else {
                    //         newToken = selectedLimitRed.Token;
                    //     }
                    //     setChipList(newToken);
                    // } else {
                    //     setChipList(selectedLimitRed.Token);
                    // }
                    setChipList(selectedLimitRed.Token);
                    setSelectedBetRule(selectedLimitRed);
                }
            }
        }
    }, [
        limitRedByGameType,
        currentGameType,
        MinBetMultiplier,
        needAutoSelect.current,
    ]);
    // default select first chip logic
    // const setPendingBetState = (hostId: number, value: boolean) => {
    //     let havePending = haveNonConfirmedBetTables.concat();
    //     if (value) {
    //         if (havePending.indexOf(hostId) < 0) {
    //             havePending.push(hostId);
    //             sethaveNonConfirmedBetTables([...havePending]);
    //         }
    //     } else {
    //         if (havePending.indexOf(hostId) >= 0) {
    //             havePending.splice(havePending.indexOf(hostId), 1);
    //             sethaveNonConfirmedBetTables([...havePending]);
    //         }
    //     }
    // };
    return {
        chipList,
        selectedBetRule,
        selectedChip,
        // currentTable,
        // currentGameId,
        // withHold,
        // allPendingBets,
        // allPendingBetsAmount,
        // allPendingWithHoldAmount,
        // haveNonConfirmedBetTables,
        // setPendingBetState,
        handleChipClick,
        // setCurrentTable,
        selectedBetAmount,
    };
};
export type useBetChipState = ReturnType<typeof useBetChip>;
